import { useMemo } from 'react';
import { useFeatureFlag } from './useFeatureFlag';
// we can rove this custom hook once we upgrade to or higher 15.14.x mui version
export const useComboboxRole = ({ label }: { label: string }) => {
  const isTiwScreenReaderEnabled = useFeatureFlag('isTiwScreenReaderEnabled');
  const comboboxRole = useMemo(
    () => ({
      role: 'combobox',
      'aria-label': label
    }),
    [label]
  );
  if (isTiwScreenReaderEnabled) {
    return comboboxRole;
  }
  return undefined;
};
